import { gql } from "@apollo/client"


export const CANCEL_SESSION = gql`
mutation CancelSession($iltID: UUID!, $sessionID: UUID!) {
  cancelSession(iltID: $iltID, sessionID: $sessionID) {
    success
    message
  }
}`

export const ACTIVATE_SESSION = gql`
mutation ActivateSession($iltID: UUID!, $sessionID: UUID!) {
  activateSession(iltID: $iltID, sessionID: $sessionID) {
    success
    message
  }
}`